/* ============================================================
   KASSANDRE PARIS — WHOLESALE JS
   ============================================================ */
/* Portail revendeur : marquer le body pour masquer le header du thème */
(function () {
  function kwMarkPortal() {
    if (document.getElementById('kw-root') || document.getElementById('kw-gateway')) {
      document.body.classList.add('kw-portal-page');
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', kwMarkPortal);
  } else {
    kwMarkPortal();
  }
})();
(function () {
  'use strict';

  var CFG = window.KW_CONFIG || {};
  var MARKET = CFG.market || 'eu';
  var MARKET_LABEL = CFG.marketLabel || 'Europe';
  var CURRENCY = CFG.currency || '\u20AC';
  var MIN_QTY = parseInt(CFG.minQty, 10) || 3;
  var COOKIE_NAME = CFG.cookieName || ('kw_auth_' + MARKET);
  var GATEWAY_URL = CFG.gatewayUrl || '/pages/revendeurs';
  var FONT_URL = CFG.fontUrl || '';
  var SHOP_EMAIL = CFG.shopEmail || '';
  var CONTACT_EMAIL = CFG.contactEmail || 'contact@kassandreparis.com';
  var FORMSPREE_URL = 'https://formspree.io/f/xvznlgln';
  var CART_KEY = 'kw_cart_' + MARKET;
  var TERMS_KEY = 'kw_terms_' + MARKET;
  var LAST_QUOTE_KEY = 'kw_last_quote_' + MARKET;

  var cart = [];
  var modalProduct = null;
  var modalQty = MIN_QTY;
  var modalVariantId = null;
  var modalVariantTitle = null;
  var quoteSubmitted = false;
  var fontBase64 = null;

  function getCookie(name) {
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i].trim();
      if (c.indexOf(name + '=') === 0) return c.substring(name.length + 1);
    }
    return null;
  }
  function saveCart() { try { localStorage.setItem(CART_KEY, JSON.stringify(cart)); } catch (e) {} }
  function loadCart() {
    try { var raw = localStorage.getItem(CART_KEY); if (raw) cart = JSON.parse(raw); }
    catch (e) { cart = []; }
  }
  function fmt(n) { return CURRENCY + ' ' + Math.round(parseFloat(n)); }
  function cartTotal() { return cart.reduce(function (s, i) { return s + i.wholesale * i.qty; }, 0); }
  function cartCount() { return cart.reduce(function (s, i) { return s + i.qty; }, 0); }
  function generateQuoteNumber() {
    var d = new Date();
    return 'KP-' + MARKET.toUpperCase() + '-' + d.getFullYear() +
      String(d.getMonth() + 1).padStart(2, '0') + String(d.getDate()).padStart(2, '0') +
      '-' + String(Math.floor(Math.random() * 900) + 100);
  }
  function setText(id, t) { var el = document.getElementById(id); if (el) el.textContent = t; }
  function val(id) { var el = document.getElementById(id); return el ? el.value.trim() : ''; }
  function escHtml(s) {
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function showScreen(id) {
    document.querySelectorAll('.kw-screen').forEach(function (s) { s.style.display = 'none'; });
    var el = document.getElementById(id);
    if (el) el.style.display = (id === 'kw-terms-screen') ? 'flex' : 'block';
    var onCatalogue = (id === 'kw-catalogue-screen');
    var pad = document.getElementById('kw-pad');
    if (pad) {
      pad.classList.remove('kw-pad--open');
      pad.style.display = onCatalogue ? '' : 'none';
    }
    var bar = document.getElementById('kw-mobile-bar');
    if (bar) bar.style.display = (onCatalogue && cartCount() > 0) ? 'flex' : 'none';
  }
  function isAuthenticated() { return getCookie(COOKIE_NAME) === 'ok'; }
  function hasAcceptedTerms() { try { return sessionStorage.getItem(TERMS_KEY) === 'ok'; } catch (e) { return false; } }

  function init() {
    loadCart();
    updateCartUI();
    var inEditor = (window.Shopify && window.Shopify.designMode);
    var isPreview = window.location.search.indexOf('kw_preview=1') !== -1;
    var bypass = inEditor || isPreview;
    if (!isAuthenticated() && !bypass) { window.location.replace(GATEWAY_URL); return; }
    if (!hasAcceptedTerms() && !bypass) {
      showScreen('kw-terms-screen');
    } else {
      showScreen('kw-catalogue-screen');
      bindCatalogueEvents();
      renderPad();
    }
  }

  function bindTermsScreen() {
    var check = document.getElementById('kw-terms-check');
    var btn = document.getElementById('kw-terms-btn');
    if (check) check.addEventListener('change', function () { if (btn) btn.disabled = !this.checked; });
    if (btn) btn.addEventListener('click', function () {
      try { sessionStorage.setItem(TERMS_KEY, 'ok'); } catch (e) {}
      showScreen('kw-catalogue-screen');
      bindCatalogueEvents();
      renderPad();
    });
  }

  /* ---------- DELEGATION GLOBALE MARGIN (cartes + modal) ----------
     Un seul listener pour tous les boutons .kw-margin-toggle.
     Gere les cartes (drawer = element suivant) ET le modal
     (drawer = #kw-modal-margin-drawer). Fiable meme apres re-render. */
  function bindGlobalMarginToggle() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.kw-margin-toggle');
      if (!btn) return;
      var expanded = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!expanded));
      var drawer;
      if (btn.id === 'kw-modal-margin-toggle') {
        drawer = document.getElementById('kw-modal-margin-drawer');
      } else {
        drawer = btn.nextElementSibling;
      }
      if (drawer && drawer.classList.contains('kw-margin-drawer')) {
        if (expanded) drawer.setAttribute('hidden', ''); else drawer.removeAttribute('hidden');
      }
    });
  }

  function bindCatalogueEvents() {
    document.querySelectorAll('[data-action="open-modal"]').forEach(function (btn) {
      if (btn.dataset.bound) return; btn.dataset.bound = '1';
      btn.addEventListener('click', function () {
        var card = this.closest('.kw-card');
        if (card) openModal(card);
      });
    });
    var padClose = document.getElementById('kw-pad-close');
    if (padClose && !padClose.dataset.bound) {
      padClose.dataset.bound = '1';
      padClose.addEventListener('click', function () {
        document.getElementById('kw-pad').classList.remove('kw-pad--open');
      });
    }
    var mobileBar = document.getElementById('kw-mobile-bar');
    if (mobileBar && !mobileBar.dataset.bound) {
      mobileBar.dataset.bound = '1';
      mobileBar.addEventListener('click', function () {
        document.getElementById('kw-pad').classList.add('kw-pad--open');
      });
    }
    var goToQuote = document.getElementById('kw-go-to-quote');
    if (goToQuote && !goToQuote.dataset.bound) {
      goToQuote.dataset.bound = '1';
      goToQuote.addEventListener('click', function () {
        showScreen('kw-quote-page');
        renderQuotePage();
        window.scrollTo(0, 0);
      });
    }
  }

  function openModal(card) {
    modalProduct = {
      id: card.dataset.productId,
      url: card.dataset.productUrl,
      title: card.dataset.productTitle,
      wholesale: parseFloat(card.dataset.wholesale),
      retail: parseFloat(card.dataset.retail),
      minQty: parseInt(card.dataset.minQty, 10) || MIN_QTY,
      variants: [], imgSrc: null, sku: ''
    };
    var img = card.querySelector('.kw-card__img');
    if (img) modalProduct.imgSrc = img.src;
    try {
      var raw = card.dataset.variants;
      if (raw) modalProduct.variants = JSON.parse(raw.replace(/&quot;/g, '"').replace(/&#39;/g, "'"));
    } catch (e) {}
    var refEl = card.querySelector('.kw-card__ref');
    if (refEl) modalProduct.sku = refEl.textContent.replace('R\u00e9f.', '').replace('Ref.', '').trim();

    modalQty = modalProduct.minQty;
    modalVariantId = null; modalVariantTitle = null;

    var mImg = document.getElementById('kw-modal-img');
    var mPh = document.getElementById('kw-modal-img-placeholder');
    if (modalProduct.imgSrc) {
      if (mImg) { mImg.src = modalProduct.imgSrc; mImg.removeAttribute('hidden'); }
      if (mPh) mPh.setAttribute('hidden', '');
    } else {
      if (mImg) mImg.setAttribute('hidden', '');
      if (mPh) mPh.removeAttribute('hidden');
    }

    setText('kw-modal-title', modalProduct.title);
    setText('kw-modal-ref', modalProduct.sku ? ('R\u00e9f. ' + modalProduct.sku) : '');
    setText('kw-modal-wholesale', fmt(modalProduct.wholesale));
    setText('kw-modal-retail', fmt(modalProduct.retail));

    var link = document.getElementById('kw-modal-product-link');
    if (link) link.href = modalProduct.url || '#';

    updateModalMargin();

    var qtyVal = document.getElementById('kw-modal-qty-val');
    if (qtyVal) { if ('value' in qtyVal) qtyVal.value = modalQty; else qtyVal.textContent = modalQty; }

    var vWrap = document.getElementById('kw-modal-variants-wrap');
    var vCont = document.getElementById('kw-modal-variants');
    if (vCont) vCont.innerHTML = '';
    var valid = modalProduct.variants.filter(function (v) { return v.available; });
    if (valid.length > 1 && vWrap && vCont) {
      vWrap.style.display = '';
      valid.forEach(function (v, i) {
        var b = document.createElement('button');
        b.className = 'kw-variant-btn' + (i === 0 ? ' kw-variant-btn--active' : '');
        b.textContent = v.title;
        if (i === 0) { modalVariantId = v.id; modalVariantTitle = v.title; }
        b.addEventListener('click', function () {
          vCont.querySelectorAll('.kw-variant-btn').forEach(function (x) { x.classList.remove('kw-variant-btn--active'); });
          this.classList.add('kw-variant-btn--active');
          modalVariantId = v.id; modalVariantTitle = v.title;
        });
        vCont.appendChild(b);
      });
    } else {
      if (vWrap) vWrap.style.display = 'none';
      if (valid.length === 1) { modalVariantId = valid[0].id; modalVariantTitle = valid[0].title; }
    }

    var mt = document.getElementById('kw-modal-margin-toggle');
    var md = document.getElementById('kw-modal-margin-drawer');
    if (mt) mt.setAttribute('aria-expanded', 'false');
    if (md) md.setAttribute('hidden', '');

    var modal = document.getElementById('kw-product-modal');
    if (modal) modal.removeAttribute('hidden');
    document.body.style.overflow = 'hidden';
  }

  function updateModalMargin() {
    if (!modalProduct) return;
    var isFr = (CFG.lang === 'fr');
    var mu = modalProduct.retail - modalProduct.wholesale;
    var pct = Math.round((mu / modalProduct.retail) * 100);
    var coeff = (modalProduct.retail / modalProduct.wholesale).toFixed(2);
    setText('kw-modal-margin-unit', fmt(mu));
    setText('kw-modal-margin-pct', pct + ' %');
    setText('kw-modal-coeff', '\u00d7 ' + coeff);
    setText('kw-modal-margin-total', fmt(mu * modalQty));
    setText('kw-modal-margin-qty-label', (isFr ? 'Sur ' : 'On ') + modalQty + (isFr ? ' unit\u00e9s' : ' units'));
  }

  function closeModal() {
    var modal = document.getElementById('kw-product-modal');
    if (modal) modal.setAttribute('hidden', '');
    document.body.style.overflow = '';
    modalProduct = null;
  }

  function bindModalEvents() {
    var cb = document.getElementById('kw-modal-close');
    if (cb) cb.addEventListener('click', closeModal);
    var ov = document.getElementById('kw-modal-overlay');
    if (ov) ov.addEventListener('click', closeModal);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeModal(); });

    var minus = document.getElementById('kw-modal-qty-minus');
    var plus = document.getElementById('kw-modal-qty-plus');
    var qv = document.getElementById('kw-modal-qty-val');

    function setQty(n) {
      var floor = (modalProduct && modalProduct.minQty) ? modalProduct.minQty : MIN_QTY;
      if (isNaN(n) || n < floor) n = floor;
      modalQty = n;
      if (qv) { if ('value' in qv) qv.value = modalQty; else qv.textContent = modalQty; }
      updateModalMargin();
    }

    if (minus) minus.addEventListener('click', function () {
      if (modalProduct) setQty(modalQty - 1);
    });
    if (plus) plus.addEventListener('click', function () {
      if (modalProduct) setQty(modalQty + 1);
    });
    if (qv && 'value' in qv) {
      qv.addEventListener('input', function () {
        var n = parseInt(this.value, 10);
        if (!isNaN(n)) { modalQty = n; updateModalMargin(); }
      });
      qv.addEventListener('blur', function () { setQty(parseInt(this.value, 10)); });
      qv.addEventListener('keydown', function (e) { if (e.key === 'Enter') { this.blur(); } });
    }

    var add = document.getElementById('kw-modal-add-btn');
    if (add) add.addEventListener('click', function () {
      if (!modalProduct) return;
      addToCart(modalProduct, modalQty, modalVariantId, modalVariantTitle);
      closeModal();
      document.getElementById('kw-pad').classList.add('kw-pad--open');
    });
  }

  function addToCart(product, qty, variantId, variantTitle) {
    var key = product.id + '_' + (variantId || 'default');
    var existing = cart.find(function (i) { return i.key === key; });
    if (existing) {
      existing.qty += qty;
    } else {
      cart.push({
        key: key, productId: product.id, title: product.title,
        wholesale: product.wholesale, retail: product.retail, qty: qty,
        minQty: product.minQty || MIN_QTY,
        variantId: variantId || null, variantTitle: variantTitle || null,
        imgSrc: product.imgSrc || null, sku: product.sku || ''
      });
    }
    saveCart(); updateCartUI(); renderPad();
  }

  function removeFromCart(key) {
    cart = cart.filter(function (i) { return i.key !== key; });
    saveCart(); updateCartUI(); renderPad(); renderQuotePage();
  }

  function updateCartItemQty(key, dir) {
    var item = cart.find(function (i) { return i.key === key; });
    if (!item) return;
    var floor = item.minQty || MIN_QTY;
    var newQty = item.qty + dir;
    if (newQty < floor) { removeFromCart(key); return; }
    item.qty = newQty;
    saveCart(); updateCartUI(); renderPad(); renderQuotePage();
  }

  function updateCartUI() {
    var c = cartCount();
    setText('kw-pad-count', c);
    setText('kw-mobile-count', c);
    var mt = document.getElementById('kw-mobile-total');
    if (mt) mt.textContent = c > 0 ? fmt(cartTotal()) : '';
    var bar = document.getElementById('kw-mobile-bar');
    var catEl = document.getElementById('kw-catalogue-screen');
    var onCat = catEl && catEl.style.display !== 'none';
    if (bar) bar.style.display = (c > 0 && onCat) ? 'flex' : 'none';
  }

  function renderPad() {
    var empty = document.getElementById('kw-pad-empty');
    var list = document.getElementById('kw-pad-list');
    var footer = document.getElementById('kw-pad-footer');
    var total = document.getElementById('kw-pad-total');
    if (!list) return;
    list.innerHTML = '';
    if (cart.length === 0) {
      if (empty) empty.style.display = '';
      if (footer) footer.style.display = 'none';
      return;
    }
    if (empty) empty.style.display = 'none';
    if (footer) footer.style.display = '';
    if (total) total.textContent = fmt(cartTotal());

    cart.forEach(function (item) {
      var li = document.createElement('li');
      li.className = 'kw-pad__item';
      var imgHtml = item.imgSrc
        ? '<img src="' + escHtml(item.imgSrc) + '" alt="" class="kw-pad__item-img">'
        : '<span class="kw-pad__item-img-ph"></span>';
      var variant = (item.variantTitle && item.variantTitle !== 'Default Title')
        ? '<p class="kw-pad__item-variant">' + escHtml(item.variantTitle) + '</p>' : '';
      li.innerHTML =
        imgHtml +
        '<div class="kw-pad__item-info">' +
          '<p class="kw-pad__item-title">' + escHtml(item.title) + '</p>' + variant +
          '<div class="kw-pad__item-qty">' +
            '<button class="kw-pad__qty-btn" data-key="' + escHtml(item.key) + '" data-dir="-1" aria-label="-">\u2212</button>' +
            '<span class="kw-pad__qty-val">' + item.qty + '</span>' +
            '<button class="kw-pad__qty-btn" data-key="' + escHtml(item.key) + '" data-dir="1" aria-label="+">+</button>' +
          '</div>' +
        '</div>' +
        '<div class="kw-pad__item-right">' +
          '<span class="kw-pad__item-subtotal">' + fmt(item.wholesale * item.qty) + '</span>' +
          '<button class="kw-pad__item-remove" data-key="' + escHtml(item.key) + '" aria-label="x">' +
            '<svg width="11" height="11" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M2 2l12 12M14 2L2 14"/></svg>' +
          '</button>' +
        '</div>';
      list.appendChild(li);
    });

    list.querySelectorAll('.kw-pad__qty-btn').forEach(function (b) {
      b.addEventListener('click', function () { updateCartItemQty(this.dataset.key, parseInt(this.dataset.dir, 10)); });
    });
    list.querySelectorAll('.kw-pad__item-remove').forEach(function (b) {
      b.addEventListener('click', function () { removeFromCart(this.dataset.key); });
    });
  }

  function renderQuotePage() {
    var tbody = document.getElementById('kw-quote-table-body');
    var totalEl = document.getElementById('kw-quote-total');
    if (!tbody) return;
    tbody.innerHTML = '';
    cart.forEach(function (item) {
      var tr = document.createElement('tr');
      var variant = (item.variantTitle && item.variantTitle !== 'Default Title') ? escHtml(item.variantTitle) : '\u2014';
      tr.innerHTML =
        '<td>' + escHtml(item.title) + '</td>' +
        '<td>' + variant + '</td>' +
        '<td>' + item.qty + '</td>' +
        '<td>' + fmt(item.wholesale) + '</td>' +
        '<td>' + fmt(item.wholesale * item.qty) + '</td>' +
        '<td><button class="kw-quote-table__remove" data-key="' + escHtml(item.key) + '" aria-label="x">' +
          '<svg width="11" height="11" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M2 2l12 12M14 2L2 14"/></svg></button></td>';
      tbody.appendChild(tr);
    });
    tbody.querySelectorAll('.kw-quote-table__remove').forEach(function (b) {
      b.addEventListener('click', function () { removeFromCart(this.dataset.key); });
    });
    if (totalEl) totalEl.textContent = fmt(cartTotal());
  }

  function bindQuotePageEvents() {
    var back = document.getElementById('kw-back-to-catalogue');
    if (back) back.addEventListener('click', function () { showScreen('kw-catalogue-screen'); });
    var form = document.getElementById('kw-quote-form');
    if (form) form.addEventListener('submit', function (e) { e.preventDefault(); submitQuote(); });
    var pdfBtn = document.getElementById('kw-download-pdf');
    if (pdfBtn) pdfBtn.addEventListener('click', function () {
      var data = collectFormData();
      if (!validateForm(data)) { showFormError(); return; }
      buildPDF(data, getQuoteNumber());
    });
  }

  function collectFormData() {
    return {
      firstname: val('kw-contact-firstname'), lastname: val('kw-contact-lastname'),
      company: val('kw-contact-company'), siret: val('kw-contact-siret'),
      phone: val('kw-contact-phone'), email: val('kw-contact-email'),
      address: val('kw-contact-address'), zip: val('kw-contact-zip'),
      city: val('kw-contact-city'), country: val('kw-contact-country'),
      notes: val('kw-contact-notes'),
      accepted: (document.getElementById('kw-accept-terms') || {}).checked
    };
  }
  function validateForm(d) {
    var req = ['firstname', 'lastname', 'company', 'phone', 'email', 'address', 'zip', 'city', 'country'];
    for (var i = 0; i < req.length; i++) { if (!d[req[i]]) return false; }
    if (!d.accepted) return false;
    if (cart.length === 0) return false;
    return true;
  }
  function showFormError() {
    var el = document.getElementById('kw-form-error');
    if (el) { el.style.display = ''; el.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
  }

  var _quoteNum = null;
  function getQuoteNumber() { if (!_quoteNum) _quoteNum = generateQuoteNumber(); return _quoteNum; }

  function readConditions() {
    var conds = {};
    document.querySelectorAll('.kw-conditions__list li').forEach(function (li) {
      var label = li.querySelector('span');
      if (!label) return;
      conds[label.textContent.trim()] = li.textContent.replace(label.textContent, '').trim();
    });
    return conds;
  }

  function submitQuote() {
    if (quoteSubmitted) return;
    var data = collectFormData();
    if (!validateForm(data)) { showFormError(); return; }
    var err = document.getElementById('kw-form-error');
    if (err) err.style.display = 'none';

    var quoteNumber = getQuoteNumber();
    var btn = document.getElementById('kw-submit-btn');
    var isFr = (CFG.lang === 'fr');
    if (btn) { btn.disabled = true; btn.textContent = isFr ? 'Envoi en cours\u2026' : 'Sending\u2026'; }

    var snapshotCart = cart.slice();

    buildPDF(data, quoteNumber, function (pdfBlob) {
      sendToFormspree(data, quoteNumber, snapshotCart, pdfBlob, function (success) {
        if (success) {
          try { localStorage.setItem(LAST_QUOTE_KEY, JSON.stringify({ n: quoteNumber, cart: snapshotCart, data: data })); } catch (e) {}
          quoteSubmitted = true;
          var ok = document.getElementById('kw-form-success');
          if (ok) ok.style.display = '';
          if (btn) btn.style.display = 'none';
          cart = []; saveCart(); updateCartUI(); renderPad();
          _quoteNum = null;
        } else {
          if (btn) { btn.disabled = false; btn.textContent = isFr ? 'Envoyer le devis' : 'Send quote'; }
          if (err) { err.textContent = isFr ? 'Envoi impossible. R\u00e9essayez ou contactez-nous.' : 'Sending failed. Please retry or contact us.'; err.style.display = ''; }
        }
      });
    });
  }

  function sendToFormspree(d, quoteNumber, snapCart, pdfBlob, done) {
    var conds = readConditions();
    var isFr = (CFG.lang === 'fr');
    var L = isFr ? {
      title: 'DEVIS REVENDEUR', market: 'March\u00e9', order: 'COMMANDE',
      total: 'TOTAL HT', terms: 'CONDITIONS', notes: 'NOTES',
      subj: 'Devis revendeur'
    } : {
      title: 'WHOLESALE QUOTE', market: 'Market', order: 'ORDER',
      total: 'TOTAL (excl. tax)', terms: 'TERMS', notes: 'NOTES',
      subj: 'Wholesale quote'
    };
    var summary = snapCart.map(function (i) {
      var v = (i.variantTitle && i.variantTitle !== 'Default Title') ? ' \u2014 ' + i.variantTitle : '';
      return '\u2022 ' + i.title + v + ' x' + i.qty + ' = ' + fmt(i.wholesale * i.qty);
    }).join('\n');
    var total = snapCart.reduce(function (s, i) { return s + i.wholesale * i.qty; }, 0);
    var condTxt = Object.keys(conds).map(function (k) { return k + ' : ' + conds[k]; }).join('\n');

    var message =
      L.title + ' ' + quoteNumber + '\n' +
      L.market + ' : ' + MARKET_LABEL + '\n\n' +
      L.order + '\n' + summary + '\n\n' +
      L.total + ' : ' + fmt(total) + '\n\n' +
      (condTxt ? L.terms + '\n' + condTxt + '\n\n' : '') +
      (d.notes ? L.notes + ' : ' + d.notes + '\n' : '');

    var fd = new FormData();
    fd.append('_subject', L.subj + ' ' + MARKET_LABEL + ' \u2014 ' + d.company + ' (' + quoteNumber + ')');
    fd.append('Quote', quoteNumber);
    fd.append('Market', MARKET_LABEL);
    fd.append('Company', d.company);
    fd.append('Contact', d.firstname + ' ' + d.lastname);
    fd.append('Email', d.email);
    fd.append('Phone', d.phone);
    fd.append('VAT', d.siret || '\u2014');
    fd.append('Address', d.address + ', ' + d.zip + ' ' + d.city + ', ' + d.country);
    fd.append('Total', fmt(total));
    fd.append('Order', summary);
    if (condTxt) fd.append('Terms', condTxt);
    if (d.notes) fd.append('Notes', d.notes);
    fd.append('message', message);
    if (d.email) fd.append('_replyto', d.email);
    if (pdfBlob) fd.append('PDF', pdfBlob, 'Kassandre-' + quoteNumber + '.pdf');

    fetch(FORMSPREE_URL, { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } })
      .then(function (r) { done(r.ok); })
      .catch(function () { done(false); });
  }

  function loadScript(src, cb) {
    var s = document.createElement('script'); s.src = src; s.onload = cb; document.head.appendChild(s);
  }
  function toBase64(buf) {
    var bytes = new Uint8Array(buf), bin = '';
    for (var i = 0; i < bytes.length; i++) bin += String.fromCharCode(bytes[i]);
    return btoa(bin);
  }
  function loadImageData(url, bgFill) {
    return new Promise(function (resolve) {
      var img = new Image(); img.crossOrigin = 'anonymous';
      img.onload = function () {
        var cv = document.createElement('canvas'); cv.width = img.width; cv.height = img.height;
        var ctx = cv.getContext('2d');
        if (bgFill) { ctx.fillStyle = bgFill; ctx.fillRect(0, 0, cv.width, cv.height); }
        ctx.drawImage(img, 0, 0);
        try { resolve({ data: cv.toDataURL('image/jpeg', 0.85), w: img.width, h: img.height }); }
        catch (e) { resolve(null); }
      };
      img.onerror = function () { resolve(null); };
      img.src = url;
    });
  }

  function buildPDF(d, quoteNumber, cb) {
    function go() {
      var tasks = [];
      var LOGO = 'https://cdn.shopify.com/s/files/1/0936/3806/6519/files/KASSANDRE_LOGO_BLACK_1_1.png?v=1765547938';
      tasks.push(loadImageData(LOGO, '#faf8f1').then(function (r) { return { logo: r }; }));
      cart.forEach(function (it, idx) {
        if (it.imgSrc) tasks.push(loadImageData(it.imgSrc, '#faf8f1').then(function (r) { return { idx: idx, img: r }; }));
      });
      var fontTask = fontBase64 ? Promise.resolve(fontBase64)
        : (FONT_URL ? fetch(FONT_URL).then(function (r) { return r.arrayBuffer(); }).then(function (b) { fontBase64 = toBase64(b); return fontBase64; }).catch(function () { return null; })
                    : Promise.resolve(null));
      Promise.all([fontTask, Promise.all(tasks)]).then(function (res) {
        renderPDF(d, quoteNumber, res[0], res[1], cb);
      }).catch(function () { if (cb) cb(null); });
    }
    if (!window.jspdf) loadScript('https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js', go);
    else go();
  }

  function renderPDF(d, quoteNumber, fontB64, assets, cb) {
    var jsPDF = window.jspdf.jsPDF;
    var doc = new jsPDF({ unit: 'mm', format: 'a4', orientation: 'portrait' });
    var W = 210, H = 297, M = 20, MUTE = [128, 117, 109];
    var FONT = 'helvetica';
    if (fontB64) {
      try { doc.addFileToVFS('Akz.ttf', fontB64); doc.addFont('Akz.ttf', 'Akzidenz', 'normal'); FONT = 'Akzidenz'; } catch (e) {}
    }
    var logo = null, imgs = {};
    (assets || []).forEach(function (a) {
      if (!a) return;
      if (a.logo !== undefined) logo = a.logo;
      else if (a.img !== undefined) imgs[a.idx] = a.img;
    });
    function bg() { doc.setFillColor(250, 248, 241); doc.rect(0, 0, W, H, 'F'); }
    var y = 0;
    function header() {
      bg(); y = 16;
      if (logo && logo.data) {
        var lw = 42, lh = lw * (logo.h / logo.w);
        doc.addImage(logo.data, 'JPEG', W / 2 - lw / 2, y, lw, lh);
        y += lh + 5;
      } else {
        doc.setFont(FONT, 'normal'); doc.setFontSize(20); doc.setTextColor(29, 9, 2);
        doc.setCharSpace(3); doc.text('KASSANDRE', W / 2, y + 7, { align: 'center' });
        doc.setCharSpace(0); y += 14;
      }
      doc.setDrawColor(29, 9, 2); doc.setLineWidth(0.4); doc.line(M, y, W - M, y); y += 9;
    }
    function tableHead() {
      doc.setFillColor(29, 9, 2); doc.rect(M, y - 5, W - M * 2, 9, 'F');
      doc.setFont(FONT, 'normal'); doc.setFontSize(7); doc.setTextColor(250, 248, 241); doc.setCharSpace(0.8);
      doc.text(CFG.lang === 'fr' ? 'PRODUIT' : 'PRODUCT', M + 22, y);
      doc.text(CFG.lang === 'fr' ? 'QT\u00c9' : 'QTY', M + 88, y);
      doc.text(CFG.lang === 'fr' ? 'P.U. HT' : 'UNIT', M + 110, y);
      doc.text(CFG.lang === 'fr' ? 'TOTAL HT' : 'TOTAL', W - M, y, { align: 'right' });
      doc.setCharSpace(0); y += 10;
    }
    header();
    doc.setFont(FONT, 'normal'); doc.setFontSize(15); doc.setTextColor(29, 9, 2); doc.setCharSpace(1.5);
    doc.text(CFG.lang === 'fr' ? 'DEVIS' : 'QUOTE', M, y); doc.setCharSpace(0); y += 8;
    var colR = W / 2 + 6;
    doc.setFontSize(9); doc.setTextColor(29, 9, 2);
    var ly = y, ry = y;
    var name = (d.firstname + ' ' + d.lastname).trim();
    if (name) { doc.text(name, M, ly); ly += 5; }
    if (d.company) { doc.text(d.company, M, ly); ly += 5; }
    if (d.siret) { doc.setFontSize(8); doc.setTextColor.apply(doc, MUTE); doc.text(d.siret, M, ly); doc.setFontSize(9); doc.setTextColor(29, 9, 2); ly += 5; }
    if (d.address) { doc.text(d.address, M, ly); ly += 5; }
    if (d.zip || d.city) { doc.text((d.zip + ' ' + d.city).trim(), M, ly); ly += 5; }
    if (d.country) { doc.text(d.country, M, ly); ly += 5; }
    if (d.email) { doc.setFontSize(8); doc.setTextColor.apply(doc, MUTE); doc.text(d.email, M, ly); ly += 4; doc.text(d.phone, M, ly); ly += 4; doc.setFontSize(9); doc.setTextColor(29, 9, 2); }
    var today = new Date().toLocaleDateString(CFG.lang === 'fr' ? 'fr-FR' : 'en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' });
    doc.text('N\u00b0 ' + quoteNumber, colR, ry); ry += 6;
    doc.text(today, colR, ry); ry += 6;
    doc.text(MARKET_LABEL, colR, ry); ry += 6;
    y = Math.max(ly, ry) + 6;
    tableHead();
    doc.setTextColor(29, 9, 2);
    cart.forEach(function (it, idx) {
      var rowH = 16;
      if (y + rowH > H - 45) { doc.addPage(); header(); tableHead(); }
      if (imgs[idx] && imgs[idx].data) {
        var iw = 13, ih = 13, r = imgs[idx].w / imgs[idx].h;
        if (r > 1) { ih = iw / r; } else { iw = ih * r; }
        var ox = (13 - iw) / 2, oy = (13 - ih) / 2;
        try { doc.addImage(imgs[idx].data, 'JPEG', M + ox, y - 4 + oy, iw, ih); } catch (e) {}
      } else {
        doc.setFillColor(240, 236, 227); doc.rect(M, y - 4, 13, 13, 'F');
      }
      var title = it.title.length > 34 ? it.title.substring(0, 32) + '\u2026' : it.title;
      doc.setFont(FONT, 'normal'); doc.setFontSize(8.5); doc.setTextColor(29, 9, 2);
      doc.text(title, M + 22, y + 1);
      if (it.variantTitle && it.variantTitle !== 'Default Title') {
        doc.setFontSize(7); doc.setTextColor.apply(doc, MUTE); doc.text(it.variantTitle, M + 22, y + 6);
      }
      if (it.sku) {
        doc.setFontSize(6.5); doc.setTextColor.apply(doc, MUTE); doc.text('R\u00e9f. ' + it.sku, M + 22, y + 10);
      }
      doc.setFontSize(9); doc.setTextColor(29, 9, 2);
      doc.text(String(it.qty), M + 88, y + 1);
      doc.text(CURRENCY + ' ' + Math.round(it.wholesale), M + 110, y + 1);
      doc.text(CURRENCY + ' ' + Math.round(it.wholesale * it.qty), W - M, y + 1, { align: 'right' });
      doc.setDrawColor(230, 225, 216); doc.setLineWidth(0.2); doc.line(M, y + 12, W - M, y + 12);
      y += rowH;
    });
    y += 2; doc.setDrawColor(29, 9, 2); doc.setLineWidth(0.4); doc.line(M, y, W - M, y); y += 7;
    doc.setFontSize(8); doc.setTextColor.apply(doc, MUTE); doc.setCharSpace(0.8);
    doc.text(CFG.lang === 'fr' ? 'TOTAL HT ESTIM\u00c9' : 'ESTIMATED TOTAL', M, y);
    doc.setFontSize(13); doc.setTextColor(29, 9, 2); doc.setCharSpace(0.3);
    doc.text(CURRENCY + ' ' + Math.round(cartTotal()), W - M, y, { align: 'right' });
    doc.setCharSpace(0); y += 11;
    var conds = readConditions();
    var keys = Object.keys(conds);
    if (keys.length) {
      if (y > H - 55) { doc.addPage(); header(); }
      doc.setFontSize(7); doc.setTextColor.apply(doc, MUTE); doc.setCharSpace(1);
      doc.text(CFG.lang === 'fr' ? 'CONDITIONS COMMERCIALES' : 'COMMERCIAL TERMS', M, y); doc.setCharSpace(0); y += 6;
      keys.forEach(function (k) {
        doc.setFontSize(8); doc.setTextColor.apply(doc, MUTE); doc.text(k, M, y);
        doc.setTextColor(29, 9, 2); doc.text(conds[k], M + 45, y); y += 5;
      });
      y += 4;
    }
    if (d.notes) {
      doc.setFontSize(7); doc.setTextColor.apply(doc, MUTE); doc.setCharSpace(1);
      doc.text('NOTES', M, y); doc.setCharSpace(0); y += 5;
      doc.setFontSize(8); doc.setTextColor(29, 9, 2);
      doc.splitTextToSize(d.notes, W - M * 2).forEach(function (l) { doc.text(l, M, y); y += 5; });
    }
    var totalP = doc.internal.getNumberOfPages();
    for (var p = 1; p <= totalP; p++) {
      doc.setPage(p);
      doc.setFont(FONT, 'normal'); doc.setTextColor.apply(doc, MUTE); doc.setCharSpace(0);
      doc.setFontSize(8);
      doc.text('contact@kassandreparis.com', W / 2, H - 20, { align: 'center' });
      doc.setDrawColor(220, 214, 204); doc.setLineWidth(0.2); doc.line(M, H - 16, W - M, H - 16);
      doc.setFontSize(6.5);
      doc.text('Kassandre Paris', W / 2, H - 11, { align: 'center' });
      doc.text(p + ' / ' + totalP, W - M, H - 6, { align: 'right' });
    }
    doc.save('Kassandre-Devis-N\u00b0' + quoteNumber + '.pdf');
    if (cb) {
      try { cb(doc.output('blob')); } catch (e) { cb(null); }
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    var sb = document.getElementById('kw-submit-btn');
    if (sb) {
      sb.disabled = false;
      sb.style.display = '';
      sb.textContent = (CFG.lang === 'fr') ? 'Envoyer le devis' : 'Send quote';
    }
    bindGlobalMarginToggle();
    init();
    bindTermsScreen();
    bindModalEvents();
    bindQuotePageEvents();
  });

})();